import * as React from 'react';
import { PortalContainer } from 'uxp/components';
interface IThemeSelectorProps<T> {
    themes:T[];
    onRender:(props:T)=>JSX.Element;
    onSelect:(props:T)=>void;
    onClose:()=>void;
}

export function ThemeSelector<T>(props:IThemeSelectorProps<T>):JSX.Element {
    return <PortalContainer hasBackdrop={true}  onClickBackdrop={()=>props.onClose()}>
        <div className='uxp-theme-selector'>
            <div className='uxp-theme-selector-title'>
                Select a theme
                <div className='closer' onClick={()=>props.onClose()}>{'✕'}</div>
                </div>
            <div className='uxp-theme-selector-list'>
                {props.themes.map((p, i) => {
                    return <div key={i} className='uxp-theme-item' onClick={() => props?.onSelect?.(p)}>
                        {props?.onRender?.(p)}
                    </div>
                })}
            </div>
        </div>
    </PortalContainer> 
  ;

}